import {Text, Title} from '../components'

const inlineStylesHeading3 = {marginTop: 40}

export const options = {
	paragraph: (_, children) => <Text lineHeight={2.5}>{children}</Text>,
	'heading-3': (_, children) => <Title styles={inlineStylesHeading3}>{children}</Title>,
}
